import { MentionData } from '@draft-js-plugins/mention';

import { groupBy } from './groupBy';
import { MENTION_TYPES } from '../consts';

export function canShowCategory(
  suggestions: MentionData[],
  mention: MentionData,
) {
  const groups = groupBy<MentionData>(
    suggestions,
    ({ type }) =>
      MENTION_TYPES[type.toLocaleUpperCase() as keyof typeof MENTION_TYPES],
  );
  return Object.keys(groups)
    .map((group: string) => groups[group]?.[0]?.id)
    .includes(mention.id);
}
